var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"post-datails-container"},[(_vm.post)?_c('post',{attrs:{"item":_vm.post},on:{"update-post":_vm.getPost}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }